import { render, staticRenderFns } from "./NewDops.vue?vue&type=template&id=13acad6e"
import script from "./NewDops.vue?vue&type=script&lang=js"
export * from "./NewDops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports